module.exports = __webpack_public_path__ + "static/media/documents (1).e958bb7d.svg";